import * as React from "react";

function SvgBBiconsKontaktniOsoba(props) {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <g data-name="Obecn\xE9 ikony">
        <path
          d="M43.13 27.31a15.82 15.82 0 00-15.82 15.82v113.74a15.82 15.82 0 0015.82 15.82h113.74a15.82 15.82 0 0015.82-15.82V43.13a15.82 15.82 0 00-15.82-15.82zm0 7.91h20.95v129.56H43.13a7.9 7.9 0 01-7.91-7.91V43.13a7.9 7.9 0 017.91-7.91zM118.58 57a26.23 26.23 0 11-26.66 26.2A26.44 26.44 0 01118.58 57zm0 5.43a20.8 20.8 0 1021.2 20.81 21 21 0 00-21.2-20.85zm21.62 41a2.89 2.89 0 011 .37 42.79 42.79 0 0120.68 36.54 2.72 2.72 0 01-5.44 0 37.37 37.37 0 00-18.08-31.9 2.71 2.71 0 011.8-5zm-44.08.1a2.76 2.76 0 012.75 1.26 2.72 2.72 0 01-.9 3.73A37.39 37.39 0 0080 140.32a2.72 2.72 0 11-5.44 0 42.78 42.78 0 0120.51-36.44 2.58 2.58 0 011.05-.37z"
          data-name="Kontaktni osoba"
        />
      </g>
    </svg>
  );
}

export default SvgBBiconsKontaktniOsoba;
